import http from "../utils/http-common";

const baseHistoryPath = "api/waste-water-treatment-history";

export const getOptionsFilter = (query: string) => {
  return http.get(`${baseHistoryPath}/options/filter-waste-water-logs?${query}`);
};

export const getHistory = (query: string) => {
  return http.get(`${baseHistoryPath}?${query}`);
};
